export const defaultConfig: DynamicConfig = {
  Name: "development",
  ApiUrl: "https://coreservices.allocate-dev.co.uk/Identityapi/TESTDEVELOP/",
  Domain: "allocate-identity-qa.eu.auth0.com",
  ClientId: "Xx7OCWU3r6yX8xN0TfzMqxqpE0i3dPyY",
  Audience: "https://identityv2.allocate-cloud.co.uk/",
  Scope: "openid profile email healthsuite",
  Host: "http://localhost:3000/",
  Region: "EU",
  TrustsClaimKey: ""
};

export interface DynamicConfig {
  Name: string;
  ApiUrl: string;
  Domain: string;
  ClientId: string;
  Audience: string;
  Scope: string;
  Host: string;
  Region: string;
  TrustsClaimKey: string;
}

class GlobalConfig {
  config: DynamicConfig = defaultConfig;
  notDefinedYet = true;

  public get(): DynamicConfig {
    if (this.notDefinedYet) {
      throw new Error(
        "Global config has not been defined yet. Be sure to call the getter only after the config has been downloaded and set. Probable cause is accessing globalConfig in static context."
      );
    } else {
      return this.config;
    }
  }

  public set(value: DynamicConfig): void {
    if (this.notDefinedYet) {
      this.config = value;
      this.notDefinedYet = false;
    } else {
      throw new Error(
        "Global config has already been defined and now has been called second time. This is probably not intended."
      );
    }
  }
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = "../config.json";
